module.exports = __webpack_public_path__ + "assets/img/loader-a2.297b48b5.gif";